var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 71,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "sound_svg__a",
    d: "M0 0h7.796v25.456H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sound_svg__c",
    d: "M0 0h7.795v19.094H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.357 22.864)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sound_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sound_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.898 25.456C1.746 25.456 0 24.034 0 22.272V3.184C0 1.428 1.746 0 3.898 0s3.898 1.428 3.898 3.184v19.088c0 1.762-1.746 3.184-3.898 3.184",
    fill: "#231F20",
    mask: "url(#sound_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.84 57.866c-2.152 0-3.897-1.422-3.897-3.184V16.5c0-1.757 1.745-3.18 3.897-3.18 2.152 0 3.898 1.423 3.898 3.18v38.18c0 1.763-1.746 3.185-3.898 3.185M35.426 48.32c-2.152 0-3.898-1.422-3.898-3.184V26.048c0-1.756 1.746-3.184 3.898-3.184s3.898 1.428 3.898 3.184v19.088c0 1.762-1.746 3.184-3.898 3.184M51.011 61.048c-2.152 0-3.898-1.423-3.898-3.184V13.32c0-1.756 1.746-3.184 3.898-3.184s3.898 1.428 3.898 3.184v44.544c0 1.761-1.746 3.184-3.898 3.184M66.596 70.593c-2.151 0-3.897-1.422-3.897-3.183V3.772c0-1.756 1.746-3.179 3.897-3.179 2.152 0 3.898 1.423 3.898 3.179V67.41c0 1.761-1.746 3.183-3.898 3.183M82.182 57.866c-2.152 0-3.898-1.422-3.898-3.184V16.5c0-1.757 1.746-3.18 3.898-3.18 2.151 0 3.897 1.423 3.897 3.18v38.18c0 1.763-1.746 3.185-3.897 3.185",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.869 26.045)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sound_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sound_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.898 19.094C1.746 19.094 0 17.67 0 15.909V3.184C0 1.428 1.746 0 3.898 0s3.898 1.428 3.898 3.184V15.91c0 1.762-1.746 3.185-3.898 3.185",
    fill: "#231F20",
    mask: "url(#sound_svg__d)"
  })))));
}
export default __webpack_public_path__ + "6dd230d8601192f2ffd1d92199cbe239.svg";
export { SvgSound as ReactComponent };